module.exports = __webpack_public_path__ + "img/lipstick(3).422bf95a.png";